module.exports = {"610527001":"城关街道","610527102":"尧禾镇","610527103":"杜康镇","610527104":"西固镇","610527105":"林皋镇","610527106":"史官镇","610527107":"北塬镇","610527109":"雷牙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610527.json
// module id = 2966
// module chunks = 0